import ApiService from "../api/ApiService";
import Urls from "../api/Urls";
import CONFIG from "../constants/Config";

export function syncDateByItiNumber(id) {
  return new ApiService({
      baseURL: CONFIG.API_TOUR,
      endpoint: Urls.TOUR_SYNC_DATE_ITI_NUMBER,
      endpointParams: { id },
  }).get();
}